const modalEditPhotoMyComp = {
  title: 'Edit Company Logo'
};

export default modalEditPhotoMyComp;
